<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div class="container-fluid" *ngIf="isLoaded()" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="row p-2">
      <form role="form" id="formulario" novalidate="novalidate" #element>
        <div class="col-12" *ngIf="this.project.breakdownLot.apportioned">
          <div class="alert alert-info text-center w-100">{{ 'AwardInfo.tittleCreation' | translate }}</div>
          <label class="" [attr.for]="multiSelectLote">Lotes:</label>
          <p-multiSelect #elementChild id="multiSelectLote" [options]="lotsModel" [(ngModel)]="selectedLots"
            [style]="{ width: '100%' }" (onChange)="changeLots($event)" *ngIf="pendingLots" class="w-100"
            [ngModelOptions]="{standalone: true}">
          </p-multiSelect>
        </div>
        <div class="col-12 m-t-md">
          <p-tabView>
            <p-tabPanel *ngIf="filteredTendersList.length > 0" header="{{ 'AwardInfo.tenderAward' | translate }}"
              class="col-12">
              <ng-container *ngIf="filteredTendersList">
                <p-table [value]="filteredTendersList" [rows]="20" [scrollable]="true" [responsive]="true"
                  [paginator]="false" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]"
                  (sortFunction)="sortLot($event)" [customSort]="tenderLots.length > 1"
                  class="footer-over-pagination  mb-3 col-12" [scrollable]="false" responsiveLayout="scroll">
                  <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                      <col style="width:30px">
                      <col style="width:200px">
                      <col style="width:80px" *ngIf="selectedLots.length>1&&this.project.breakdownLot.apportioned">
                      <col *ngFor="let lot of tenderLots" style="width:170px">
                    </colgroup>
                  </ng-template>
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th class="col-icon"></th>
                      <th>{{ 'AwardInfo.tender' | translate }}</th>
                      <th class="action-column text-center text-ellipsis"
                        *ngIf="selectedLots.length>1 && this.project.breakdownLot.apportioned && isAwardMultiplesLots()">
                        {{ 'General.actions' | translate }}</th>
                      <th class="text-center text-ellipsis" *ngFor="let lot of tenderLots"
                        pSortableColumn="{{lot.lotId}}">
                        <ng-container *ngIf="lot.lotId === 0"> </ng-container>
                        <ng-container *ngIf="lot.lotId !== 0">
                          <p-sortIcon field="{{lot.lotId}}"></p-sortIcon><span
                            pTooltip="{{ lot.lotNumber }} - {{ lot.description }}" tooltipPosition="top">{{
                            lot.lotNumber }} - {{ lot.description }}</span>
                        </ng-container>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-tender let-columns="columns">
                    <tr *ngIf="tender.document?.currentState?.identifier !== '13'">
                      <td class="col-icon">
                        <span><i class="fa fa-2x fa-file-signature"></i><span class="sr-only"></span></span>
                      </td>
                      <td *ngIf="tender?.tendererParty?.company?.name  !== undefined"> {{
                        tender?.tendererParty?.company?.name }} - {{
                        tender?.tendererParty?.company?.extendedDataIdentifier }}</td>
                      <td *ngIf="tender?.tendererParty?.company?.name  === undefined"> {{ tender?.description }} - {{
                        tender?.tendererParty?.company?.extendedDataIdentifier }}</td>
                      <td class="text-center" *ngIf="isAwardMultiplesLots()">
                        <button class="btn btn-sm btn-primary" (debounceClick)="createAwardByTender(tender)"
                          pTooltip="{{ 'AwardInfo.tenderAward' | translate }} - {{ tender?.tendererParty?.company?.name }}"
                          title="{{ 'AwardInfo.tenderAward' | translate }} - {{ tender?.tendererParty?.company?.name }}"
                          appDebounceClick>
                          <i class="fas fa-gavel" aria-hidden="true"></i>
                        </button>
                      </td>
                      <td *ngFor="let lot of tenderLots">
                        <ng-template #tenderLot let-tLot="tLot" let-tender="tender">
                          <ng-container *ngIf="tLot; else noLot">
                            <div
                              [ngClass]="(tLot.tenderEvaluation?.objectiveAwardCriteriaTotalScore!==undefined  || tLot.tenderEvaluation?.subjectiveAwardCriteriaTotalScore!==undefined ) ? 'text-right' : 'text-center'"
                              *ngIf="tLot.tenderEvaluation?.admissionStatus=== undefined || tLot.tenderEvaluation?.admissionStatus?.statusCode === undefined ||tLot.tenderEvaluation?.admissionStatus?.statusCode == TenderAdmissionStatusCode.ACEPTED">
                              <span
                                *ngIf="tLot.tenderEvaluation?.objectiveAwardCriteriaTotalScore!==undefined || tLot.tenderEvaluation?.subjectiveAwardCriteriaTotalScore!==undefined"
                                pTooltip="{{ 'AwardInfo.classification' | translate }}: {{ getClasification(tender, tLot) + '\n'}}{{ 'AwardInfo.score' | translate }}: {{ (tLot.tenderEvaluation.objectiveAwardCriteriaTotalScore+tLot.tenderEvaluation.subjectiveAwardCriteriaTotalScore) | currency:' ' }}"
                                class="mt-1 badge badge-filter font-weight-normal m-r-2"> {{
                                'AwardInfo.classificationShort' | translate }}: {{ getClasification(tender, tLot)}} <i
                                  *ngIf="getClasification(tender, tLot)===1" class="fa fa-trophy text-warning"></i>
                                ({{(tLot.tenderEvaluation.objectiveAwardCriteriaTotalScore+tLot.tenderEvaluation.subjectiveAwardCriteriaTotalScore)
                                | currency:' '}}) </span>
                              <button *ngIf="!isAwardMultiplesLots()" #elementChild
                                class="btn btn-sm btn-secondary m-l-xs t-action-button"
                                pTooltip="{{ (tenderLots.length>1 ? 'AwardInfo.buttonAwardLot' : 'AwardInfo.tenderAward') | translate }}{{ (tenderLots.length>1 ? ' - '+lot.description : '') }} - {{ tender?.tendererParty?.company?.name }}"
                                title="{{ (tenderLots.length>1 ? 'AwardInfo.buttonAwardLot' : 'AwardInfo.tenderAward') | translate }}{{ (tenderLots.length>1 ? ' - '+lot.description : '') }} - {{ tender?.tendererParty?.company?.name }}"
                                aria-expanded="false" (click)="createAwardByTender(tender, tLot)" autofocus>
                                <i class="fas fa-plus" aria-hidden="true"></i>
                              </button>
                              <i *ngIf="isAwardMultiplesLots()" class="far fa-lg fa-check-circle m-l-xs text-success"
                                aria-hidden="true"></i>
                            </div>
                          </ng-container>
                          <ng-template #noLot></ng-template>
                        </ng-template>
                        <ng-container *ngTemplateOutlet="
                      tenderLot;
                      context: {
                        tender: tender,
                        tLot: getTenderLotById(tender, lot.lotNumber)
                      }
                    "></ng-container>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr class="text-center">
                      <td colspan="3"> {{ 'General.noFilteredData' | translate }} </td>
                    </tr>
                  </ng-template>
                </p-table>
              </ng-container>
            </p-tabPanel>
            <p-tabPanel *ngIf="isAwardCompanyAvailable()" header="{{ 'AwardInfo.companyAward' | translate }}"
              class="col-12">
              <div class="container-fluid">
                <div class="row p-0">
                  <div class="col-12 p-0">
                    <formElement [model]="award" [fieldConfig]="getFieldConfig()"></formElement>
                    <button class="btn btn-sm btn-primary " appDebounceClick
                      (debounceClick)="createAwardByCompany(award.company)" aria-expanded="false">
                      <i class="fas fa-gavel" aria-hidden="true">
                      </i>
                      <span class="d-none d-md-inline"> {{ 'AwardInfo.buttonAward' | translate
                        }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel *ngIf="!isAwardCompanyAvailable() && filteredTendersList.length == 0" class="col-12">
              <div class="container-fluid">
                <div class="row p-0">
                  <div class="col-12 p-0">
                    <span class="d-none d-md-inline"> No se pueden crear adjudicaciones si no hay ofertas
                      asociadas.</span>
                  </div>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </form>
    </div>
  </div>
</p-scrollPanel>